<div class="everymatrix-mm-verification-report">
  <div class="report-wrapper">
    @let lookups = lookupsSignal(); @let domainLookups = domainLookupsSignal();
    @let visibleFields = visibleFieldsSignal();

    <div class="report-header-container">
      <div class="report-titles-container">
        <h1 class="report-title">Verification Report</h1>
        <h2 class="template-title">{{ templateLabel }}</h2>
      </div>
      @if (ready() && filterForm) {
      <lib-template-select-modal
        [reportId]="reportId"
        [domainLookups]="domainLookups"
        [(templateCsvLoadingConfig)]="templateCsvLoadingConfig"
        (csvLoadEmitter)="downloadCsv($event)"
        (runReportEmitter)="runReport(0, false)"
        [isShowSendSettings]="true"
      ></lib-template-select-modal>
      }
    </div>
    @if (attachedToShadowDom()) {
    <p-panel #panel [toggleable]="true">
      <ng-template #header>
        <div
          class="panel-header-container"
          [ngStyle]="{ width: isPanelOpened ? '100%' : '98%' }"
        >
          <div class="panel-header-left">
            <span class="panel-header-title">Filters</span>
            @if (!isPanelOpened) {
            <span
              class="panel-header-title-sub"
              [pTooltip]="getFilledFieldNames()"
              tooltipPosition="top"
              >{{ getFilledFieldNames() }}</span
            >
            }
          </div>
          @if (ready() && filterForm && isPanelOpened) {
          <div
            class="panel-header-right"
            [ngStyle]="{ 'margin-right': '16px' }"
          >
            <lib-dm-button-lib
              size="medium"
              variant="secondary-outlined"
              [disabled]="filterForm && !filterForm.dirty"
              (outsideClickEmitter)="setPrevVisibleFields(); clearFilters()"
            >
              <div
                class="dm-button-icon"
                icon-right
                [ngStyle]="{ height: '20px' }"
              >
                <svg
                  pTooltip="Reset Filters"
                  tooltipPosition="top"
                  positionLeft="10"
                  positionTop="-5"
                  xmlns="http://www.w3.org/2000/svg"
                  width="20"
                  height="20"
                  viewBox="0 0 20 20"
                  fill="none"
                >
                  <path
                    fill-rule="evenodd"
                    clip-rule="evenodd"
                    d="M0.833496 10C0.833496 5.39763 4.56446 1.66667 9.16683 1.66667C11.4688 1.66667 13.5541 2.60117 15.0614 4.10949C15.5945 4.64289 16.1653 5.30207 16.6668 5.91204V3.33334C16.6668 2.8731 17.0399 2.50001 17.5002 2.50001C17.9604 2.50001 18.3335 2.8731 18.3335 3.33334V8.33334C18.3335 8.79358 17.9604 9.16667 17.5002 9.16667H12.5002C12.0399 9.16667 11.6668 8.79358 11.6668 8.33334C11.6668 7.8731 12.0399 7.50001 12.5002 7.50001H15.8078C15.231 6.77607 14.5139 5.91947 13.8825 5.28759C12.675 4.07929 11.0088 3.33334 9.16683 3.33334C5.48493 3.33334 2.50016 6.31811 2.50016 10C2.50016 13.6819 5.48493 16.6667 9.16683 16.6667C12.2049 16.6667 14.7704 14.6337 15.573 11.8523C15.7006 11.4101 16.1625 11.1551 16.6047 11.2827C17.0469 11.4103 17.302 11.8722 17.1744 12.3144C16.1714 15.7901 12.9672 18.3333 9.16683 18.3333C4.56446 18.3333 0.833496 14.6024 0.833496 10Z"
                    fill="#5D6983"
                  />
                </svg>
              </div>
            </lib-dm-button-lib>
            <lib-dm-button-lib
              text="Configure Report"
              size="medium"
              variant="secondary-outlined"
              (outsideClickEmitter)="setPrevVisibleFields(); configureReportModalVisible.set(true)"
            >
              <div class="dm-button-icon" icon-left>
                <svg
                  xmlns="http://www.w3.org/2000/svg"
                  width="18"
                  height="14"
                  viewBox="0 0 18 14"
                  fill="none"
                >
                  <path
                    d="M1.5 3.66667H11.5M11.5 3.66667C11.5 5.04738 12.6192 6.16667 14 6.16667C15.3807 6.16667 16.5 5.04738 16.5 3.66667C16.5 2.28596 15.3807 1.16667 14 1.16667C12.6192 1.16667 11.5 2.28596 11.5 3.66667ZM6.5 10.3333H16.5M6.5 10.3333C6.5 11.7141 5.38071 12.8333 4 12.8333C2.61929 12.8333 1.5 11.7141 1.5 10.3333C1.5 8.95258 2.61929 7.83333 4 7.83333C5.38071 7.83333 6.5 8.95258 6.5 10.3333Z"
                    stroke="#5D6983"
                    stroke-width="2"
                    stroke-linecap="round"
                    stroke-linejoin="round"
                  />
                </svg>
              </div>
            </lib-dm-button-lib>
          </div>
          }
        </div>
      </ng-template>

      <ng-template pTemplate="icons">
        @if (visibleFields && visibleFields.length) { @if (isPanelOpened) {
        <svg
          xmlns="http://www.w3.org/2000/svg"
          width="20"
          height="20"
          viewBox="0 0 20 20"
          fill="none"
          (click)="isPanelOpened = false; panel.toggle($event); applyTableHeight(false);"
          pTooltip="Collapse Filters"
          tooltipPosition="top"
          positionLeft="10"
          positionTop="-5"
          class="panel-icons"
        >
          <path
            fill-rule="evenodd"
            clip-rule="evenodd"
            d="M9.41009 6.91075C9.73553 6.58531 10.2632 6.58531 10.5886 6.91075L15.5886 11.9107C15.914 12.2362 15.914 12.7638 15.5886 13.0893C15.2632 13.4147 14.7355 13.4147 14.4101 13.0893L9.99935 8.67852L5.5886 13.0893C5.26317 13.4147 4.73553 13.4147 4.41009 13.0893C4.08466 12.7638 4.08466 12.2362 4.41009 11.9107L9.41009 6.91075Z"
            fill="#5D6983"
          />
        </svg>
        } @else {
        <svg
          pTooltip="Expand Filters"
          tooltipPosition="top"
          positionLeft="10"
          positionTop="-5"
          class="panel-icons"
          xmlns="http://www.w3.org/2000/svg"
          width="20"
          height="20"
          viewBox="0 0 20 20"
          fill="none"
          (click)="isPanelOpened = true; panel.toggle($event); applyTableHeight(true);"
        >
          <path
            fill-rule="evenodd"
            clip-rule="evenodd"
            d="M4.41107 6.91083C4.73651 6.58539 5.26414 6.58539 5.58958 6.91083L10.0003 11.3216L14.4111 6.91083C14.7365 6.58539 15.2641 6.58539 15.5896 6.91083C15.915 7.23626 15.915 7.7639 15.5896 8.08934L10.5896 13.0893C10.2641 13.4148 9.73651 13.4148 9.41107 13.0893L4.41107 8.08934C4.08563 7.7639 4.08563 7.23626 4.41107 6.91083Z"
            fill="#5D6983"
          />
        </svg>
        } }
      </ng-template>
      @if (ready() && filterForm) {
      <form [formGroup]="filterForm">
        <div class="filters-content">
          <div class="filter-options">
            @for (field of visibleFields; track field['field_id']) { @if
            (field['field_data_type'] === 'LOOKUP') {
            <lib-dm-select-lib
              optionLabel="lookup_value"
              optionValue="lookup_key"
              [isMultiSelect]="true"
              [label]="field['field_name']"
              [placeholder]="field['field_name']"
              [isRequired]="field['field_id'] === 'merchant_name'"
              [options]="
                lookups
                  ? field['field_id'] === 'merchant_name'
                    ? domainLookups
                    : lookups[field['lookup_param_key']]
                  : []
              "
              [formControlName]="field.field_id"
            />
            } @else if (field['field_data_type'] === 'TIMESTAMP') {
            <lib-dm-range-date-picker-lib
              [tooltipMessage]="
                field['field_id'] === 'verification_updated_date' ||
                field['field_id'] === 'verification_creation_date'
                  ? 'You must specify at least one field: Create Date or Last Update'
                  : ''
              "
              [infoIcon]="
                field['field_id'] === 'verification_updated_date' ||
                field['field_id'] === 'verification_creation_date'
              "
              [isRequired]="
                field['field_id'] === 'verification_updated_date' && !filterForm?.get('verification_creation_date')?.value?.start ||
                field['field_id'] === 'verification_creation_date' && !filterForm?.get('verification_updated_date')?.value?.start
              "
              [label]="field['field_name']"
              [formControlName]="field.field_id"
              [control]="getControl(field.field_id)"
              [maxDate]="maxDay"
            />
            } @else if (field['field_data_type'] === 'STRING' ||
            field['field_data_type'] === 'BIGNUMERIC' ||
            field['field_data_type'] === 'INT64') { @if (field['field_id'] ===
            'documents') {
            <lib-dm-input-text-lib
              (clickEmitter)="documentsModal = true"
              [showClear]="false"
              [label]="field['field_name']"
              [readonly]="true"
              [placeholder]="field['field_name']"
              [control]="getControl(field.field_id)"
              [inputPartName]="'documents-modal-button-custom-styles'"
            >
              <div
                icon-right
                class="dm-input-icon icon-right clear-icon"
                style="right: 33px"
              >
                @if(getControl(field.field_id).value) {
                <svg
                  (click)="onDocumentsClear()"
                  width="12"
                  height="14"
                  viewBox="0 0 14 14"
                  fill="none"
                  xmlns="http://www.w3.org/2000/svg"
                  aria-hidden="true"
                >
                  <path
                    d="M8.01186 7.00933L12.27 2.75116C12.341 2.68501 12.398 2.60524 12.4375 2.51661C12.4769 2.42798 12.4982 2.3323 12.4999 2.23529C12.5016 2.13827 12.4838 2.0419 12.4474 1.95194C12.4111 1.86197 12.357 1.78024 12.2884 1.71163C12.2198 1.64302 12.138 1.58893 12.0481 1.55259C11.9581 1.51625 11.8617 1.4984 11.7647 1.50011C11.6677 1.50182 11.572 1.52306 11.4834 1.56255C11.3948 1.60204 11.315 1.65898 11.2488 1.72997L6.99067 5.98814L2.7325 1.72997C2.59553 1.60234 2.41437 1.53286 2.22718 1.53616C2.03999 1.53946 1.8614 1.61529 1.72901 1.74767C1.59663 1.88006 1.5208 2.05865 1.5175 2.24584C1.5142 2.43303 1.58368 2.61419 1.71131 2.75116L5.96948 7.00933L1.71131 11.2675C1.576 11.403 1.5 11.5866 1.5 11.7781C1.5 11.9696 1.576 12.1532 1.71131 12.2887C1.84679 12.424 2.03043 12.5 2.2219 12.5C2.41338 12.5 2.59702 12.424 2.7325 12.2887L6.99067 8.03052L11.2488 12.2887C11.3843 12.424 11.568 12.5 11.7594 12.5C11.9509 12.5 12.1346 12.424 12.27 12.2887C12.4053 12.1532 12.4813 11.9696 12.4813 11.7781C12.4813 11.5866 12.4053 11.403 12.27 11.2675L8.01186 7.00933Z"
                    fill="#5D6983"
                  ></path>
                </svg>
                }
              </div>
              <div
                (click)="documentsModal = true"
                class="dm-input-icon icon-right"
                icon-right
              >
                <svg
                  xmlns="http://www.w3.org/2000/svg"
                  width="16"
                  height="16"
                  viewBox="0 0 20 20"
                  fill="none"
                >
                  <path
                    d="M2.5 6.66666H12.5M12.5 6.66666C12.5 8.04737 13.6192 9.16666 15 9.16666C16.3807 9.16666 17.5 8.04736 17.5 6.66666C17.5 5.28595 16.3807 4.16666 15 4.16666C13.6192 4.16666 12.5 5.28595 12.5 6.66666ZM7.5 13.3333H17.5M7.5 13.3333C7.5 14.7141 6.38071 15.8333 5 15.8333C3.61929 15.8333 2.5 14.7141 2.5 13.3333C2.5 11.9526 3.61929 10.8333 5 10.8333C6.38071 10.8333 7.5 11.9526 7.5 13.3333Z"
                    stroke="#5D6983"
                    stroke-width="2"
                    stroke-linecap="round"
                    stroke-linejoin="round"
                  />
                </svg>
              </div>
            </lib-dm-input-text-lib>
            } @else {
            <lib-dm-input-text-lib
              [label]="field['field_name']"
              [control]="getControl(field.field_id)"
              [placeholder]="field['field_name']"
            />
            } } }
            <div class="form-control-container last-updated-checkbox">
              <p-checkbox
                inputId="lastUpdate"
                formControlName="show_last_verification"
                [binary]="true"
              />
              <label for="lastUpdate" class="form-control-label" [ngStyle]="{ 'padding-top': '2px' }"
                >Show only latest status</label
              >
              <span
                [ngStyle]="{ display: 'inline-flex', cursor: 'pointer' }"
                [pTooltip]="tooltipContent"
                tooltipPosition="top"
              > 
                <ng-template #tooltipContent>
                  <div class="flex items-center">
                    When enabled, only the most recent<br/> status per document will be shown.
                  </div>
                </ng-template>

                <svg xmlns="http://www.w3.org/2000/svg" width="16" height="16" viewBox="0 0 16 16" fill="none">
                  <g clip-path="url(#clip0_1833_5701)">
                    <path fill-rule="evenodd" clip-rule="evenodd" d="M8.00033 2.00033C4.68662 2.00033 2.00033 4.68662 2.00033 8.00033C2.00033 11.314 4.68662 14.0003 8.00033 14.0003C11.314 14.0003 14.0003 11.314 14.0003 8.00033C14.0003 4.68662 11.314 2.00033 8.00033 2.00033ZM0.666992 8.00033C0.666992 3.95024 3.95024 0.666992 8.00033 0.666992C12.0504 0.666992 15.3337 3.95024 15.3337 8.00033C15.3337 12.0504 12.0504 15.3337 8.00033 15.3337C3.95024 15.3337 0.666992 12.0504 0.666992 8.00033ZM7.33366 5.33366C7.33366 4.96547 7.63213 4.66699 8.00033 4.66699H8.00699C8.37518 4.66699 8.67366 4.96547 8.67366 5.33366C8.67366 5.70185 8.37518 6.00033 8.00699 6.00033H8.00033C7.63213 6.00033 7.33366 5.70185 7.33366 5.33366ZM8.00033 7.33366C8.36852 7.33366 8.66699 7.63213 8.66699 8.00033V10.667C8.66699 11.0352 8.36852 11.3337 8.00033 11.3337C7.63213 11.3337 7.33366 11.0352 7.33366 10.667V8.00033C7.33366 7.63213 7.63213 7.33366 8.00033 7.33366Z" fill="#5D6983"/>
                  </g>
                  <defs>
                    <clipPath id="clip0_1833_5701">
                      <rect width="16" height="16" fill="white"/>
                    </clipPath>
                  </defs>
                </svg>
              </span>
            </div>
          </div>
          <div class="filter-actions">
            <lib-dm-button-lib
              text="Save Template"
              size="medium"
              variant="primary-outlined"
              [disabled]="!isTemplateSavingEnabled"
              (outsideClickEmitter)="openSaveTemplateModal()"
            >
              <div class="dm-button-icon" icon-left>
                <svg
                  xmlns="http://www.w3.org/2000/svg"
                  width="20"
                  height="20"
                  viewBox="0 0 20 20"
                  fill="none"
                >
                  <path
                    fill-rule="evenodd"
                    clip-rule="evenodd"
                    d="M12.8369 3.35637C12.7633 3.3387 12.6754 3.33335 12.2281 3.33335H6.66602V5.33335C6.66602 5.58045 6.66666 5.71566 6.6746 5.81282C6.67492 5.81669 6.67524 5.82035 6.67556 5.82381C6.67902 5.82413 6.68268 5.82444 6.68654 5.82476C6.7837 5.8327 6.91891 5.83335 7.16602 5.83335H12.8327C13.0798 5.83335 13.215 5.8327 13.3122 5.82476C13.316 5.82444 13.3197 5.82413 13.3231 5.82381C13.3235 5.82035 13.3238 5.81669 13.3241 5.81282C13.332 5.71566 13.3327 5.58045 13.3327 5.33335V3.68005C13.1758 3.52644 13.1264 3.48596 13.0777 3.45615C13.0032 3.41046 12.9219 3.37679 12.8369 3.35637ZM14.7552 2.74398L14.703 2.69181C14.6865 2.67531 14.6701 2.65893 14.6539 2.64269C14.4144 2.4027 14.2032 2.19111 13.9486 2.03508C13.7249 1.89801 13.481 1.797 13.2259 1.73576C12.9356 1.66604 12.6366 1.66632 12.2975 1.66664C12.2746 1.66666 12.2514 1.66668 12.2281 1.66668L6.46493 1.66668C6.25739 1.66668 6.06106 1.66667 5.87552 1.66776C5.86133 1.66704 5.84705 1.66668 5.83268 1.66668C5.81429 1.66668 5.79604 1.66728 5.77795 1.66845C5.40448 1.67155 5.07624 1.68008 4.78949 1.70351C4.32108 1.74178 3.89049 1.82392 3.48605 2.02999C2.85884 2.34957 2.34891 2.8595 2.02933 3.48671C1.82325 3.89116 1.74112 4.32174 1.70284 4.79016C1.666 5.24115 1.66601 5.79479 1.66602 6.4656V13.5344C1.66601 14.2052 1.666 14.7589 1.70284 15.2099C1.74112 15.6783 1.82325 16.1089 2.02933 16.5133C2.34891 17.1405 2.85884 17.6505 3.48605 17.97C3.89049 18.1761 4.32108 18.2582 4.78949 18.2965C5.07624 18.3199 5.40448 18.3285 5.77794 18.3316C5.79604 18.3328 5.81429 18.3333 5.83268 18.3333C5.84705 18.3333 5.86133 18.333 5.87552 18.3323C6.06105 18.3334 6.25737 18.3333 6.46491 18.3333H13.5338C13.7413 18.3333 13.9376 18.3334 14.1232 18.3323C14.1374 18.333 14.1516 18.3333 14.166 18.3333C14.1844 18.3333 14.2027 18.3328 14.2208 18.3316C14.5942 18.3285 14.9225 18.3199 15.2092 18.2965C15.6776 18.2582 16.1082 18.1761 16.5127 17.97C17.1399 17.6505 17.6498 17.1405 17.9694 16.5133C18.1754 16.1089 18.2576 15.6783 18.2959 15.2099C18.3327 14.7589 18.3327 14.2052 18.3327 13.5345V7.77125C18.3327 7.74792 18.3327 7.72477 18.3327 7.70182C18.333 7.36274 18.3333 7.06379 18.2636 6.77342C18.2024 6.51833 18.1014 6.27447 17.9643 6.05079C17.8083 5.79618 17.5967 5.58498 17.3567 5.34544C17.3404 5.32922 17.3241 5.31288 17.3076 5.29638L14.7552 2.74398C14.7552 2.74405 14.7551 2.74391 14.7552 2.74398ZM14.9994 5.34519V5.35991C14.9994 5.57024 14.9994 5.77507 14.9852 5.94854C14.9697 6.13903 14.9329 6.36381 14.8177 6.59C14.6579 6.9036 14.4029 7.15857 14.0893 7.31836C13.8631 7.43361 13.6384 7.47033 13.4479 7.48589C13.2744 7.50006 13.0696 7.50004 12.8593 7.50002L7.16602 7.50001C7.15715 7.50001 7.14829 7.50001 7.13944 7.50002C6.92912 7.50004 6.72429 7.50006 6.55082 7.48589C6.36033 7.47033 6.13555 7.43361 5.90937 7.31836C5.59576 7.15857 5.34079 6.9036 5.18101 6.59C5.06576 6.36381 5.02903 6.13903 5.01347 5.94854C4.9993 5.77507 4.99932 5.57025 4.99935 5.35993C4.99935 5.35108 4.99935 5.34222 4.99935 5.33335V3.35907C4.97416 3.3608 4.94946 3.36266 4.92521 3.36464C4.55987 3.39449 4.37303 3.44859 4.2427 3.515C3.9291 3.67479 3.67413 3.92976 3.51434 4.24336C3.44793 4.3737 3.39383 4.56053 3.36398 4.92588C3.33333 5.30095 3.33268 5.7862 3.33268 6.50001V13.5C3.33268 14.2138 3.33333 14.6991 3.36398 15.0741C3.39383 15.4395 3.44793 15.6263 3.51434 15.7567C3.67413 16.0703 3.9291 16.3252 4.2427 16.485C4.37303 16.5514 4.55987 16.6055 4.92521 16.6354C4.94946 16.6374 4.97416 16.6392 4.99935 16.641L4.99935 12.1401C4.99932 11.9298 4.9993 11.725 5.01347 11.5515C5.02903 11.361 5.06576 11.1362 5.18101 10.91C5.34079 10.5964 5.59576 10.3415 5.90937 10.1817C6.13555 10.0664 6.36033 10.0297 6.55082 10.0141C6.72429 9.99996 6.92912 9.99999 7.13945 10H12.8593C13.0696 9.99999 13.2744 9.99996 13.4479 10.0141C13.6384 10.0297 13.8631 10.0664 14.0893 10.1817C14.4029 10.3415 14.6579 10.5964 14.8177 10.91C14.9329 11.1362 14.9697 11.361 14.9852 11.5515C14.9994 11.725 14.9994 11.9298 14.9994 12.1401L14.9993 16.641C15.0245 16.6392 15.0492 16.6374 15.0735 16.6354C15.4388 16.6055 15.6257 16.5514 15.756 16.485C16.0696 16.3252 16.3246 16.0703 16.4844 15.7567C16.5508 15.6263 16.6049 15.4395 16.6347 15.0741C16.6654 14.6991 16.666 14.2138 16.666 13.5V7.77125C16.666 7.32393 16.6607 7.2361 16.643 7.1625C16.6226 7.07747 16.5889 6.99618 16.5432 6.92162C16.5037 6.85708 16.4453 6.79119 16.129 6.47489L14.9994 5.34519ZM13.3327 16.6667V12.1667C13.3327 11.9196 13.332 11.7844 13.3241 11.6872C13.3238 11.6833 13.3235 11.6797 13.3231 11.6762C13.3197 11.6759 13.316 11.6756 13.3122 11.6753C13.215 11.6673 13.0798 11.6667 12.8327 11.6667H7.16602C6.91891 11.6667 6.7837 11.6673 6.68654 11.6753C6.68268 11.6756 6.67902 11.6759 6.67556 11.6762C6.67524 11.6797 6.67492 11.6833 6.6746 11.6872C6.66666 11.7844 6.66602 11.9196 6.66602 12.1667V16.6667H13.3327Z"
                    fill="#0076DD"
                  />
                </svg>
              </div>
            </lib-dm-button-lib>
            <lib-dm-button-lib
              text="Run Report"
              size="medium"
              [disabled]="
                !isFilterFormValid || runState
              "
              (outsideClickEmitter)="runOverloadCheck('Run')"
            >
              @if (!runState) {
              <div class="dm-button-icon" icon-left>
                <svg
                  xmlns="http://www.w3.org/2000/svg"
                  width="20"
                  height="20"
                  viewBox="0 0 20 20"
                  fill="none"
                >
                  <path
                    fill-rule="evenodd"
                    clip-rule="evenodd"
                    d="M10.8333 2.51654C10.6786 2.50244 10.4493 2.5 10.0098 2.5H7.33333C6.61952 2.5 6.13427 2.50065 5.7592 2.53129C5.39385 2.56114 5.20702 2.61525 5.07668 2.68166C4.76308 2.84145 4.50811 3.09641 4.34832 3.41002C4.28192 3.54035 4.22781 3.72719 4.19796 4.09253C4.16732 4.46761 4.16667 4.95285 4.16667 5.66667V14.3333C4.16667 15.0472 4.16732 15.5324 4.19796 15.9075C4.22781 16.2728 4.28192 16.4597 4.34832 16.59C4.50811 16.9036 4.76308 17.1586 5.07668 17.3183C5.20702 17.3848 5.39385 17.4389 5.7592 17.4687C6.13427 17.4994 6.61952 17.5 7.33333 17.5H12.6667C13.3805 17.5 13.8657 17.4994 14.2408 17.4687C14.6061 17.4389 14.793 17.3848 14.9233 17.3183C15.2369 17.1586 15.4919 16.9036 15.6517 16.59C15.7181 16.4597 15.7722 16.2728 15.802 15.9075C15.8327 15.5324 15.8333 15.0472 15.8333 14.3333V8.32352C15.8333 7.8841 15.8309 7.65481 15.8168 7.50006L12.9734 7.50006C12.7631 7.50009 12.5583 7.50011 12.3848 7.48594C12.1943 7.47038 11.9695 7.43365 11.7433 7.3184C11.4297 7.15862 11.1748 6.90365 11.015 6.59004C10.8997 6.36386 10.863 6.13908 10.8475 5.94859C10.8333 5.77512 10.8333 5.57029 10.8333 5.35996L10.8333 2.51654ZM11.9947 1.12497C11.8064 1.04059 11.6105 0.973736 11.4093 0.925435C11.0237 0.832866 10.6239 0.833056 10.0947 0.833308C10.0668 0.833322 10.0385 0.833335 10.0098 0.833335L7.29892 0.833335C6.62811 0.833324 6.07448 0.833315 5.62348 0.870163C5.15506 0.908434 4.72448 0.990571 4.32003 1.19665C3.69283 1.51622 3.18289 2.02616 2.86331 2.65337C2.65724 3.05781 2.5751 3.4884 2.53683 3.95681C2.49998 4.40781 2.49999 4.96144 2.5 5.63225V14.3678C2.49999 15.0386 2.49998 15.5922 2.53683 16.0432C2.5751 16.5116 2.65724 16.9422 2.86331 17.3466C3.18289 17.9738 3.69283 18.4838 4.32003 18.8034C4.72448 19.0094 5.15506 19.0916 5.62348 19.1298C6.07447 19.1667 6.6281 19.1667 7.2989 19.1667H12.7011C13.3719 19.1667 13.9255 19.1667 14.3765 19.1298C14.8449 19.0916 15.2755 19.0094 15.68 18.8034C16.3072 18.4838 16.8171 17.9738 17.1367 17.3466C17.3428 16.9422 17.4249 16.5116 17.4632 16.0432C17.5 15.5922 17.5 15.0386 17.5 14.3678V8.32352C17.5 8.29485 17.5 8.26656 17.5 8.23863C17.5003 7.70946 17.5005 7.30963 17.4079 6.92405C17.3597 6.72344 17.2931 6.52805 17.2091 6.34031C17.2039 6.32807 17.1984 6.31599 17.1926 6.30407C17.1382 6.18624 17.0768 6.07153 17.0088 5.96054C16.8016 5.62244 16.5188 5.33985 16.1444 4.96584C16.1246 4.9461 16.1046 4.92611 16.0843 4.90584L13.4275 2.24899C13.4072 2.22871 13.3872 2.2087 13.3675 2.18893C12.9935 1.81458 12.7109 1.53172 12.3728 1.32453C12.2614 1.25625 12.1462 1.19467 12.0278 1.14006C12.0169 1.1348 12.0058 1.12977 11.9947 1.12497ZM12.5 3.67851V5.3334C12.5 5.5805 12.5006 5.71571 12.5086 5.81287C12.5089 5.81673 12.5092 5.82039 12.5095 5.82385C12.513 5.82417 12.5167 5.82449 12.5205 5.82481C12.6177 5.83275 12.7529 5.83339 13 5.83339H14.6549L12.5 3.67851ZM5.83333 10.8333C5.83333 10.3731 6.20643 10 6.66667 10H13.3333C13.7936 10 14.1667 10.3731 14.1667 10.8333C14.1667 11.2936 13.7936 11.6667 13.3333 11.6667H6.66667C6.20643 11.6667 5.83333 11.2936 5.83333 10.8333ZM5.83333 14.1667C5.83333 13.7064 6.20643 13.3333 6.66667 13.3333H11.6667C12.1269 13.3333 12.5 13.7064 12.5 14.1667C12.5 14.6269 12.1269 15 11.6667 15H6.66667C6.20643 15 5.83333 14.6269 5.83333 14.1667Z"
                    fill="white"
                  />
                </svg>
              </div>
              } @else {
              <div class="dm-button-icon" icon-left>
                <p-progress-spinner
                  strokeWidth="6"
                  [style]="{ width: '20px', height: '20px' }"
                />
              </div>
              }
            </lib-dm-button-lib>
          </div>
        </div>
      </form>
      } @else {
      <div class="spinner-wrapper">
        <p-progress-spinner
          strokeWidth="6"
          [style]="{ width: '60px', height: '60px' }"
        />
      </div>
      }
    </p-panel>
    }
    <div
      class="table-panel-container"
      [ngStyle]="{ display: showReportTable() ? 'block' : 'none' }"
    >
      <p-panel [toggleable]="false" #tablePanel>
        <ng-template #header>
          <div class="panel-header-container">
            <div class="panel-header-left">
              <div class="table-toggle-container">
                <span class="table-toggle-label">Old Table Style</span>
                <p-toggleswitch
                  class="table-toggle"
                  [(ngModel)]="isOldTableStyle"
                  [ngModelOptions]="{ standalone: true }"
                  (onChange)="onToggleChange($event)"
                  pTooltip="Switch between old and new table views"
                  tooltipPosition="top"
                  showDelay="600"
                  hideDelay="300"
                ></p-toggleswitch>
              </div>
            </div>
            <div class="panel-header-right">
              <lib-dm-button-lib
                text="Download .CSV"
                size="medium"
                variant="primary-outlined"
                (outsideClickEmitter)="runOverloadCheck('Download')"
                [disabled]="!isFilterFormValid || csvLoading()"
              >
                @if(csvLoading()) {
                  <div class="dm-button-icon" icon-left>
                    <p-progress-spinner
                      styleClass="outlined-color"
                      strokeWidth="6"
                      [style]="{ width: '16px', height: '16px' }"
                    />
                  </div>
                } @else {
                  <div
                    class="dm-button-icon"
                    icon-left
                    [ngStyle]="{ height: '20px' }"
                  >
                    <svg
                      xmlns="http://www.w3.org/2000/svg"
                      width="20"
                      height="20"
                      viewBox="0 0 20 20"
                      fill="none"
                    >
                      <path
                        fill-rule="evenodd"
                        clip-rule="evenodd"
                        d="M9.99935 1.66663C10.4596 1.66663 10.8327 2.03972 10.8327 2.49996V10.4881L13.5768 7.74404C13.9022 7.4186 14.4298 7.4186 14.7553 7.74404C15.0807 8.06947 15.0807 8.59711 14.7553 8.92255L10.5886 13.0892C10.2632 13.4147 9.73553 13.4147 9.41009 13.0892L5.24343 8.92255C4.91799 8.59711 4.91799 8.06947 5.24343 7.74404C5.56886 7.4186 6.0965 7.4186 6.42194 7.74404L9.16602 10.4881V2.49996C9.16602 2.03972 9.53911 1.66663 9.99935 1.66663ZM2.49935 11.6666C2.95959 11.6666 3.33268 12.0397 3.33268 12.5V13.5C3.33268 14.2138 3.33333 14.699 3.36398 15.0741C3.39383 15.4394 3.44793 15.6263 3.51434 15.7566C3.67413 16.0702 3.9291 16.3252 4.2427 16.485C4.37303 16.5514 4.55987 16.6055 4.92521 16.6353C5.30029 16.666 5.78553 16.6666 6.49935 16.6666H13.4993C14.2132 16.6666 14.6984 16.666 15.0735 16.6353C15.4388 16.6055 15.6257 16.5514 15.756 16.485C16.0696 16.3252 16.3246 16.0702 16.4844 15.7566C16.5508 15.6263 16.6049 15.4394 16.6347 15.0741C16.6654 14.699 16.666 14.2138 16.666 13.5V12.5C16.666 12.0397 17.0391 11.6666 17.4993 11.6666C17.9596 11.6666 18.3327 12.0397 18.3327 12.5V13.5344C18.3327 14.2052 18.3327 14.7588 18.2959 15.2098C18.2576 15.6782 18.1754 16.1088 17.9694 16.5133C17.6498 17.1405 17.1399 17.6504 16.5126 17.97C16.1082 18.1761 15.6776 18.2582 15.2092 18.2965C14.7582 18.3333 14.2046 18.3333 13.5338 18.3333H6.46491C5.79411 18.3333 5.24049 18.3333 4.78949 18.2965C4.32108 18.2582 3.89049 18.1761 3.48605 17.97C2.85884 17.6504 2.34891 17.1405 2.02933 16.5133C1.82325 16.1088 1.74112 15.6782 1.70284 15.2098C1.666 14.7588 1.66601 14.2052 1.66602 13.5344L1.66602 12.5C1.66602 12.0397 2.03911 11.6666 2.49935 11.6666Z"
                        fill="#0076DD"
                      />
                    </svg>
                  </div>
                }
              </lib-dm-button-lib>
            </div>
          </div>
        </ng-template>

        <lib-dm-tree-table
          [ngStyle]="{ display: !isOldTableStyle ? 'block' : 'none' }"
          [(limit)]="limit"
          [startIndex]="offset"
          [loading]="tableLoading"
          [tableColumns]="tableColumns"
          [rawTableData]="tableData"
          [generalTotal]="generalTotal"
          (loadMoreEmitter)="runReport($event, true)"
          (sortingEmitter)="onSort($event)"
          [scrollHeight]="scrollHeight"
        ></lib-dm-tree-table>

        <dm-ui-grid-lib [options]="gridOptions"></dm-ui-grid-lib>
      </p-panel>
    </div>
    <!--  Documents Dialog-->
    @defer (when documentsModal) {
    <p-dialog
      #dialog
      header="Documents Settings"
      [modal]="true"
      [(visible)]="documentsModal"
      [style]="{ width: '480px' }"
      contentStyleClass="dialog-content-overflow-visible"
      (onShow)="onOpenDocumentsModal()"
      [closable]="false"
      [closeOnEscape]="false"
    >
      @if (ready() && filterForm) {
      <form class="dialog-content" [formGroup]="filterForm" #contentWrapper>
        <lib-dm-select-lib
          optionLabel="lookup_value"
          optionValue="lookup_key"
          label="Document Type"
          formControlName="documents_type"
          [isMultiSelect]="true"
          [options]="lookups && lookups['documents_type']"
        />
        <lib-dm-select-lib
          optionLabel="lookup_value"
          optionValue="lookup_key"
          label="Document Status"
          formControlName="documents_status"
          [isMultiSelect]="true"
          [options]="lookups && lookups['documents_status']"
        />
        <lib-dm-range-date-picker-lib
          label="Expiry Date"
          formControlName="documents_expiry_date"
          [control]="getControl('documents_expiry_date')"
          [maxDate]="maxDay"
        />
        <lib-dm-range-date-picker-lib
          label="Last Update"
          formControlName="documents_created_date"
          [control]="getControl('documents_created_date')"
          [maxDate]="maxDay"
        />
      </form>
      <div class="dialog-footer">
        <lib-dm-button-lib
          text="Cancel"
          size="medium"
          variant="secondary-outlined"
          (outsideClickEmitter)="onCancelDocumentsModal(); documentsModal = false;"
        >
        </lib-dm-button-lib>
        <lib-dm-button-lib
          text="Apply"
          size="medium"
          variant="primary-filled"
          (outsideClickEmitter)="applyDocumentField(); documentsModal = false"
          [disabled]="
            getControl('documents_expiry_date')?.hasError('endDateRequired') ||
            getControl('documents_created_date')?.hasError('endDateRequired')
          "
        >
        </lib-dm-button-lib>
      </div>
      }
    </p-dialog>
    }
  </div>
  @if (visibleFieldsId && visibleFieldsId.length && filterForm) { @defer (when
  domainsOverloadVisible()) {
  <lib-domains-overload-modal
    [(visible)]="domainsOverloadVisible"
    [isSaveMode]="domainsOverloadSaveMode"
    (confirm)="domainsOverloadConfirm($event)"
    [action]="domainsOverloadAction"
  ></lib-domains-overload-modal>
  } @defer (when modalVisible()) {
  <lib-save-template-modal
    [(visible)]="modalVisible"
    (saveEmitter)="isTemplateSaved.set(true); domainsOverloadSaveMode = false; domainsOverloadAction = '';"
    [params]="{
      fieldValues: filterForm.value,
      visibleFields: visibleFieldsId,
      allFields: allFieldsSignal()
    }"
    [reportId]="reportId"
  ></lib-save-template-modal>
  } @defer (when configureReportModalVisible()) {
  <lib-report-configuration-modal
    [(visible)]="configureReportModalVisible"
    [allAvailableFields]="allConfigurationFields"
    [selectedList]="visibleFieldsSignal()"
    (fieldsEmitter)="applyConfigurationFields($event)"
  ></lib-report-configuration-modal>
  } }
</div>
<lib-toast-message></lib-toast-message>
